import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import noop from 'lodash-es/noop';

import { FaTimes, FaTrash, FaCamera, FaSave, FaPhone, FaPrint, FaEdit, FaCheck } from 'react-icons/fa';
// FaBackspace

import styles from './Button.scss';

export const BUTTON_TYPE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    CANCEL: 'cancel',
    DARK: 'dark',
    SUCCESS: 'success',
    WARNING: 'warning',
    TRANSPARENT: 'transparent',
    RED: 'red'
};

export const BUTTON_ICON = {
    CLEAR: <FaTimes size={16} />,
    DELETE: <FaTrash size={16} />,
    CAMERA: <FaCamera size={20} />,
    SAVE: <FaSave size={20} />,
    CHECK_IN: <FaCheck size={20} />,
    PHONE: <FaPhone size={20} />,
    PHONE_MINI: <FaPhone size={10} />,
    PRINT: <FaPrint size={20} />,
    EDIT: <FaEdit size={20} />
};

/**
 * Button
 * @param   {object}    props
 * @return  {*}
 * @constructor
 */
const Button = (props) => {
    const {
        type,
        htmlType,
        icon = null,
        label = '',
        disabled = false,
        shrink = false,
        link = '',
        className = '',
        name,
        onClick = noop,
        onBlur = noop,
        alignRight = false,
        marginRight = false,
        children,
        tabIndex = ''
    } = props;
    const dataId = props['data-id'] || '';
    const componentType = link ? 'a' : 'button';
    const componentProps = {
        'data-id': dataId,
        name,
        type: htmlType,
        className: cx(
            className,
            styles.button,
            styles[type],
            {
                [styles.disabled]: !!disabled,
                [styles.shrink]: !!shrink,
                [styles.icon]: !!icon,
                [styles.alignRight]: !!alignRight,
                [styles.marginRight]: !!marginRight
            }
        ),
        onClick: !disabled ? onClick : undefined,
        onBlur: !disabled ? onBlur : undefined,
        disabled,
        ...(link ? { href: link } : {}),
        tabIndex: tabIndex ? tabIndex : undefined
    };
    const componentChildren = (label || icon || children);

    return React.createElement(
        componentType,
        componentProps,
        componentChildren
    );
};

Button.propTypes = {
    type: PropTypes.oneOf(Object.keys(BUTTON_TYPE).map(k => BUTTON_TYPE[k])).isRequired,
    icon: PropTypes.oneOf(Object.keys(BUTTON_ICON).map(k => BUTTON_ICON[k])),
    htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),
    label: PropTypes.string,
    disabled: PropTypes.bool,
    shrink: PropTypes.bool,
    alignRight: PropTypes.bool,
    marginRight: PropTypes.bool,
    link: PropTypes.string,
    className: PropTypes.string,
    name: PropTypes.string,
    'data-id': PropTypes.string,
    onClick: PropTypes.func,
    onBlur: PropTypes.func,
    tabIndex: PropTypes.string
};

export default Button;
